import React from 'react';

const Modal = ({ isOpen, onClose, title, children, wide = false }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/50 z-50 overflow-y-auto overscroll-contain [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="flex min-h-full items-center justify-center py-8 px-4">
        <div className={`bg-slate-900 border border-white/10 rounded-lg p-6 ${wide ? 'w-[560px]' : 'w-[500px]'} max-w-full`}>
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-slate-300 text-lg font-medium">{title}</h2>
            <button
              onClick={onClose}
              className="text-slate-500 hover:text-slate-400"
              aria-label="Close modal"
            >
              ✖
            </button>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;